import investments from './investments.js';

export default [...investments];
